import DeleteInputText from '@Common/components/DeleteInputText';
import { RootState } from '@Common/models/redux/store';
import { makeStyles } from '@mui/styles';
import { DeleteOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import citationGeneratorTrack from '../handlers/track';
import { removeAllCitaionList } from '../reducers/actionCreators';
import { TriggeringActions } from '../types/names';

const useStyles = makeStyles(() => ({
  deleteIcon: {
    cursor: 'pointer',
    height: 31,
    width: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 6,
    marginRight: 10,
  },
}));

export default function CitationDeleteAllIcon() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const router = useRouter();
  const isCowriter = router.pathname.includes('/co-writer');
  const citationList = useSelector((state: RootState) => state.ctgr.citationList);
  const citationsFromCowriter = useSelector((state: RootState) => state.ctgr.citationsFromCowriter);
  const citations = isCowriter ? citationsFromCowriter : citationList;

  return (
    <DeleteInputText
      isQuilling={citations.length === 0}
      clearInputText={() => {
        dispatch(removeAllCitaionList());
        citationGeneratorTrack.userClickedDeleteCitation(TriggeringActions.DELETE_ALL);
      }}
      iconButtonClass={classes.deleteIcon}
      iconButtonProps={{
        disableRipple: true,
      }}
      deleteIcon={<DeleteOutlined fontSize="small" />}
    />
  );
}
